/**
 * Turns this site's own absolute URLs into relative paths, for `next/image`.
 *
 * Payload returns absolute media URLs (`https://jeugdfilms.nl/api/media/file/…`, built from its
 * serverURL). Next's image optimizer fetches an absolute `src` over the network, and on the VPS a
 * container can't reach the host's own public address (the connection times out), so every
 * optimized image would fail. A relative `src` is fetched inside the app instead.
 *
 * Every other value — other hosts, relative paths, static imports — is returned unchanged.
 */
const ownOrigin = (() => {
  try {
    return new URL(process.env.NEXT_PUBLIC_SERVER_URL || '').origin
  } catch {
    // Without it every media URL stays absolute and the optimizer times out fetching it on the
    // VPS, so say so rather than fail image by image. NEXT_PUBLIC_SERVER_URL is inlined at build
    // time (a build arg in docker-compose.prod.yml).
    if (process.env.NODE_ENV === 'production') {
      console.warn('[toLocalSrc] NEXT_PUBLIC_SERVER_URL is not set: media URLs stay absolute, so the image optimizer cannot fetch them on the server')
    }
    return null
  }
})()

export function toLocalSrc<T>(src: T, origin: string | null = ownOrigin): T {
  if (typeof src !== 'string' || !origin) return src
  return (src.startsWith(`${origin}/`) ? src.slice(origin.length) : src) as T
}
